import { render, staticRenderFns } from "./_MenuView.vue?vue&type=template&id=8a753a0a&"
import script from "./_MenuView.vue?vue&type=script&lang=js&"
export * from "./_MenuView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports